var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oxy-properties-panel breakdance-element-properties-panel",attrs:{"data-test-id":"element-properties-panel"}},[(_vm.elementIsActive)?[_c('Titlebar',{attrs:{"size":"small"}}),_c('OxygenTabsAndControls')]:[_c('BlankSidebarContent')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }